import { cloneDeep } from "lodash";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { areRawValuesEqual } from "./areRawValuesEqual";
import { isRecord, isStyleValue } from "./typePredicates";

export interface StyleValueMap {
  [key: string]: StyleValue | StyleValueMap;
}

export const mergeNewStyles = (
  styles: StyleValueMap,
  newStyles: unknown,
  cssVariables: Record<string, string>,
): StyleValueMap => {
  if (!isRecord(newStyles)) return styles;

  const merged = cloneDeep(styles);

  for (const [key, value] of Object.entries(newStyles)) {
    const existingValue = styles[key];

    if (isStyleValue(existingValue)) {
      merged[key] = areRawValuesEqual(existingValue.value, value, cssVariables)
        ? existingValue
        : { ...existingValue, value };
    } else if (isRecord(value) && isRecord(existingValue)) {
      merged[key] = mergeNewStyles(existingValue, value, cssVariables);
    } else {
      merged[key] = existingValue;
    }
  }

  return merged;
};
